import { FC } from 'react'
import { INavItem } from 'types/ui/navItem.interface'
import { StyledNavItem } from './NavItem.styled'

export const NavItem: FC<INavItem> = ({
  label,
  icon,
  active = false,
  collapsed = false,
  onSelect,
}) => {
  return (
    <StyledNavItem
      $active={active}
      $collapsed={collapsed}
      onClick={onSelect}
      aria-current={active ? 'page' : undefined}
      aria-label={collapsed ? label : undefined}
      title={collapsed ? label : undefined}
    >
      {icon}
      {!collapsed && label}
    </StyledNavItem>
  )
}
